module.exports = __webpack_public_path__ + "static/media/WeekView.5f94805f.svg";